var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 138,
    viewBox: "0 0 258 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_359_181)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 200,
    height: 80,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 199,
    height: 79,
    rx: 19.5,
    stroke: "#EAE3D2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 46.6548L62.6354 87.0932L78.9479 92.4265L95.3646 87.0932L99 46.6548H59ZM91.1042 59.7222H71.9583L72.3854 64.7693H90.6771L89.2604 79.9312L79.0625 82.6898V82.7204H78.9479L68.6667 79.9312L68.0417 72.1868H73.0104L73.375 76.0794L78.9479 77.5609L84.5417 76.0794L85.1667 69.7245H67.7812L66.4479 54.8487H91.5625L91.1042 59.7222Z",
    fill: "#F2531E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.694 78.7123H137.884V70.2223H129.574V78.7123H125.794V58.4923H129.574V66.9523H137.884V58.4923H141.694V78.7123ZM158.642 61.6123H153.512V78.7123H149.702V61.6123H144.572V58.4923H158.642V61.6123ZM164.898 78.7123H161.118L162.738 58.4923H167.058L169.818 65.8423C170.298 67.0823 170.748 68.3223 171.168 69.5623C171.588 70.7823 171.888 71.6923 172.068 72.2923L172.338 73.2223C172.958 71.1423 173.818 68.6823 174.918 65.8423L177.738 58.4923H182.058L184.038 78.7123H180.258L179.538 70.8223L178.998 63.7423C178.278 65.8023 177.418 68.1623 176.418 70.8223L173.598 78.4123H171.018L168.258 70.8223L165.888 63.8323C165.888 64.8123 165.758 67.1423 165.498 70.8223L164.898 78.7123ZM199.544 78.7123H187.874V58.4923H191.654V75.3523H199.544V78.7123Z",
    fill: "#333333",
    fillOpacity: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_359_181",
    x: 0,
    y: 0,
    width: 258,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_359_181"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_359_181",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlTag);
export default __webpack_public_path__ + "static/media/HTMLTag.540ee8ad.svg";
export { ForwardRef as ReactComponent };